<div class="g-0">
    <div class="col">
        <div class="box-wrapper">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-circle-info"></i>
                                <span class="ms-2">Istoric Activitate</span>
                            </div>
                            <span class="action-buttons" *ngIf="istoric.length">
                                <form [formGroup]="searchParamsForm">
                                    <mat-form-field>
                                        <mat-label>Tip mesaj</mat-label>
                                        <mat-select formControlName="messageType"
                                            (selectionChange)="filterHistoryByType()">
                                            <mat-option *ngFor="let message of messageTypes" [value]="message.value">
                                                {{ message.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </form>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body p-2">
                <div *ngFor="let ist of filteredHistory; let i = index" class="box-message"
                    [class.client]="ist.type == 0" [class.to-client]="ist.type == 1" [class.intern]="ist.type == 2"
                    [class.note]="ist.type == 3" [class.me]="user.id_user == ist.id_user && ist.type !== 0">
                    <div class="box-chat">
                        <div class="box-chat-header">
                            <div>
                                <span *ngIf="ist.type == 0">Răspuns cetățean</span>
                                <span *ngIf="ist.type == 1">Mesaj către cetățean</span>
                                <span *ngIf="ist.type == 2">Mesaj intern</span>
                                <span *ngIf="ist.type == 3">Notă</span>
                            </div>

                            <!-- <div class="box-chat-header-tool-box">
								<div *ngIf="!isReportMessageLoading[ist.id_cerere_history]">
									<span class="me-2">
										<button *ngIf="ist.type == 1" type="button" class="btn btn-light"
											(click)="resendMessage(ist.id_cerere_history)">Retrimite mesaj</button>
									</span>
									<span class=" red-text" *ngIf="notifyIds.indexOf(ist.id_cerere_history) > -1">
										<i class="fa-solid fa-flag"></i>
									</span>
								</div>
								<mat-spinner *ngIf="isReportMessageLoading[ist.id_cerere_history]" diameter="30"
									color="primary"></mat-spinner>
								<div *ngIf="ist.type == 1 && ist.notify == true" class="d-flex flex-column justify-content-center align-items-start notification-await-section">
									<div >
										<small title="Necesar raspuns pana la : {{ist.notify_date_expire}}"><i class="fa-solid fa-hourglass"></i> {{ist.notify_date_expire}}</small>
									</div>
									<div >
										<small title="Mesaj vizualizat la : {{ist.notify_seen || 'În așteptare'}}"><i class="fa-regular fa-calendar"></i> {{ist.notify_seen || "În așteptare"}}</small>
									</div>
									<div *ngIf="ist.notify_seen !== null">
										<small title="Mesaj primit? :"><i class="fa-regular fa-comments"></i> 
											<span *ngIf="ist.notify_processed == 1" class="text-success"> Mesaj Primit</span>
											<span *ngIf="ist.notify_processed == 0" class="text-danger"> Așteptare Răspuns</span>
										</small>
									</div>
								</div>
							</div> -->
                        </div>

                        <div class="message-content" [innerHTML]="ist.content"></div>
                        <!-- here to add files if present!!! -->
                        <div class="doc-attachment p-2" *ngIf="ist.documente?.length">
                            <button type="button" class="btn btn-light upload-btn m-2"
                                *ngFor="let file of ist.documente" (click)="downloadDocument(file.id_document)">
                                <span class="upload__text">
                                    {{ file.name }}
                                </span>
                            </button>
                        </div>

                        <!-- Coleagues -->
                        <div *ngIf="ist.coleagues?.length && ist.type !== 0" class="notifications-container">
                            <div *ngFor="let coleague of ist.coleagues"
                                class="d-flex justify-content-end notification-item">
                                <span class="p-2" *ngIf="ist.type !== 1">
                                    <i class="fa-regular fa-user"></i> {{coleague.user.name}}
                                </span>
                                <span class="p-2" *ngIf="ist.type == 2"
                                    title="{{coleague.processed_web_date | date: 'dd-MM-yyyy HH:mm:ss'}}">
                                    <i class="fa-solid fa-flag"
                                        [style.color]="coleague.processed_web === 0 ? 'red' : 'grey'"></i>
                                </span>
                                <span class="p-2" *ngIf="ist.type !== 1"
                                    title="{{coleague.processed_email_date | date: 'dd-MM-yyyy HH:mm:ss'}}">
                                    <i class="fa-solid fa-envelope"
                                        [style.color]="coleague.processed_email === 0 ? 'red' : 'grey'"></i>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="box-chat-footer">
                        <small *ngIf="ist.type !== 0">
                            <i class="fa-regular fa-user"></i> {{ist.user.name}}
                        </small>
                        <small *ngIf="ist.type == 0">
                            <i class="fa-regular fa-user"></i> {{ist.user.name}}
                        </small>
                        <small>
                            <i class="fa-regular fa-clock"></i>
                            {{ist.created_at | date: "dd-MM-yyyy HH:mm:ss"}}
                        </small>
                    </div>
                </div>
            </div>
            <!-- <div class="section-spinner position-fixed" *ngIf="isLoading">
                    <div class="spinner position-absolute top-50 start-50 translate-middle">
                        <mat-spinner></mat-spinner>
                        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                    </div>
                </div> -->
        </div>
    </div>
</div>